export { default as DevelopmentFabric } from './page'


// WEBPACK FOOTER //
// ./src/pages/developmentFabric/index.js